import React, { useContext, useState } from "react";
import MyContext from "../../../../MyContext";
import { FaIndianRupeeSign } from "react-icons/fa6";
import { FaArrowRightLong } from "react-icons/fa6";
import "../designcss/Pricing.css";
import { useNavigate } from "react-router-dom";

const Pricing = () => {
  const { openFreeTrialModal } = useContext(MyContext);
  const navigate = useNavigate();

  const [billing, setBilling] = useState("monthly");

  return (
    <>
      <div className="pricinggcontainer-wrapper">
        <div className="pricing-container">
          <div className="heading-container">
            <p className="heading">Choose a plan that’s right for your</p>
            <p className="paraheading">
              Try our free plan risk free for 7 days. switch plans or cancel
              anytime.
            </p>

            <div className="button">
              <button
                className={`btn-monthly ${billing === "monthly" ? "active" : ""}`}
                onClick={() => setBilling("monthly")}
              >
                Monthly
              </button>

              <span
                className={`yearly ${billing === "yearly" ? "active" : ""}`}
                onClick={() => setBilling("yearly")}
                style={{ cursor: "pointer" }}
              >
                Yearly <span className="fourtypercent mx-1"> 40% </span> off
              </span>
            </div>

            <div className="card-container">
              <div className="basic-card">
                <h4 className="basic-title">Basic</h4>
                <p className="personaluse">Best for personal use.</p>

                <div className="price">
                  <FaIndianRupeeSign />
                  <span className="amount">0</span>
                  <span className="period">/ per month</span>
                </div>

                <button onClick={openFreeTrialModal} className="start-freebtn">
                  Start Free Trial
                </button>
              </div>

              <div className="enterprise-card">
                <h4 className="enterprise-title">Enterprise</h4>
                <p className="personaluse">
                  Best for growing teams & corporations.
                </p>

                <div className="enterprise">
                  <FaIndianRupeeSign />
                  <span className="amount">
                    {billing === "monthly" ? "2499" : "1799"}
                  </span>
                  <span className="period">/ per month</span>
                </div>

                <button
                  onClick={() => navigate("/login")}
                  className="start-freebtn"
                >
                  Buy Now <FaArrowRightLong />
                </button>
              </div>
            </div>
          </div>

          <section className="comparison-section">
            <table className="comparison-table">
              <thead>
                <tr>
                  <th>Features</th>
                  <th>Free Trial</th>
                  <th>Enterprise</th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td>Campaign Limit</td>
                  <td>Up to 10 Campaigns</td>
                  <td>Unlimited Campaigns</td>
                </tr>

                <tr>
                  <td>Broadcast Messages</td>
                  <td>Limited</td>
                  <td>Unlimited</td>
                </tr>

                <tr>
                  <td>Template Creation</td>
                  <td>Create up to 15 Templates</td>
                  <td>Unlimited Template Creation</td>
                </tr>

                <tr>
                  <td>Contact Management</td>
                  <td>Basic</td>
                  <td>Advanced</td>
                </tr>

                <tr>
                  <td>WhatsApp Chat Inbox</td>
                  <td>Shared Inbox</td>
                  <td>Advanced Team Inbox</td>
                </tr>

                <tr>
                  <td>User Access</td>
                  <td>5–10 Team Members</td>
                  <td>Unlimited Team Members</td>
                </tr>

                <tr>
                  <td>Chatbot / Automation Flow</td>
                  <td>Basic</td>
                  <td>Advanced Automation</td>
                </tr>

                <tr>
                  <td>Analytics & Reports</td>
                  <td>Basic Analytics</td>
                  <td>Advanced Analytics & Insights</td>
                </tr>

                <tr>
                  <td>Export Report</td>
                  <td>Limited</td>
                  <td>Unlimited</td>
                </tr>

                <tr>
                  <td>Customer Support</td>
                  <td>Email Support</td>
                  <td>Priority Support</td>
                </tr>
              </tbody>
            </table>
          </section>
        </div>
      </div>
    </>
  );
};

export default Pricing;
